import type {
  AddBankDetailData,
  ClaimReasonData,
  ClaimReasonNode,
  ViewDetailData,
} from "../types";

export enum ModalActionId {
  VIEW_TRAVELLER_DETAIL = "VIEW_TRAVELLER_DETAIL",
  ADD_BANK_DETAIL = "ADD_BANK_DETAIL",
  OPEN_CLAIM_REASON = "OPEN_CLAIM_REASON",
}

export type ModalPayloadMap = {
  [ModalActionId.VIEW_TRAVELLER_DETAIL]: ViewDetailData;
  [ModalActionId.ADD_BANK_DETAIL]: {
    data: AddBankDetailData;
    onSubmit?: (values: Record<string, string>) => void;
  };
  [ModalActionId.OPEN_CLAIM_REASON]: {
    reasonData: ClaimReasonData;
    onSelectNode: (node: ClaimReasonNode) => void;
  };
};

export type ModalState = {
  activeModal: ModalActionId | null;
  payload: ModalPayloadMap[ModalActionId] | null;
};

export type ModalOpenAction<K extends ModalActionId = ModalActionId> = {
  type: "OPEN";
  actionId: K;
  payload: ModalPayloadMap[K];
};

export type ModalCloseAction = { type: "CLOSE" };

export type ModalAction = ModalOpenAction | ModalCloseAction;
